import request from './request'
import * as http from '@/libs/http'

/**
 * 組織情報を取得する
 *
 * @param {String} orgcode 組織コード
 * @param {Array} fields 追加フィールド
 * @returns {Response} レスポンスデータ
 */
export function getOrg (orgcode, fields = []) {
  return request.get(`/org/${orgcode}`, {
    params: {
      fields: [
        'code',
        ...fields
      ]
    },
    validateStatus: (status) => [
      http.OK,
      http.NotFound
    ].includes(status)
  })
}
